export default "__VITE_ASSET__161438f2__"